import * as ActionTypes from "../Types/ActionTypes";
import Swal from "sweetalert2";
// import axios from "../../shared/axios";
import { baseUrl } from "../../shared/baseURL";
import axios from "../../shared/axios";
import history from "../../../src/myCreatedHistory";


export const registerSuccess = (register) => {
  return {
    type: ActionTypes.REGISTER_SET_DATA,
    register: register,
  };
};
export const forgotFailData = (error) => {
  return {
    type: ActionTypes.FORGOT_PASSWORD_FAIL_DATA,
    error: error,
  };
};
//loading
export const forgotLoading = () => {
  return {
    type: ActionTypes.FORGOT_PASSWORD_LOADING,
  };
};

//Add new code
export const registerUser = (data) => {
  return async (dispatch) => {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post("/register", data, config);
      
      if (response.data.error) {
        // Handle error in the response if present
        console.error("Response Error:", response.data.error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.error || "Something went wrong!",
        });
      } else {
        // Show success notification
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Successfully Registered!",
          showConfirmButton: false,
          timer: 3000,
        });

        // Dispatch successful registration action if needed
        dispatch(registerSuccess(response.data));
        history.push(`/register-success`)
      }
    } catch (error) {
      // Handle API errors
      console.error("API Error:", error);
      Swal.fire({
        icon: "error",
        title: "API Error",
        text: "Registration failed. Please try again later.",
      });

      // Optionally dispatch an error action
      // dispatch(registerFail(error.message));
    }
  };
};
